export const datadogParameters = {
  applicationId: 'e8e0e295-e521-4afb-963e-e957358a6277',
  clientToken: 'pubcbe0e87a1cfd37ec3ce0545a4d507499',
  version: '1.0.0',
};
